import { FilterDescriptor } from '@progress/kendo-data-query'
import { FieldSettings } from '@progress/kendo-react-data-tools'
import { BooleanFilter } from 'components/Filter/BooleanFilter'
import { ModalFilter } from 'components/Filter/ModalFilter'
import { SelectFilter } from 'components/Filter/SelectFilter'
import { GridFilterOperatorEnum, GridFilterOperatorNameEnum } from 'types/GridFilterOperatorEnum'

import { SelectVersion } from '../SelectVersion'
import { platformVersions } from './PlatformVersionModal'

const PlatformFilter = ({
  filter,
  onFilterChange,
}: {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}) => {
  return (
    <SelectFilter
      filter={filter}
      onFilterChange={onFilterChange}
      data={platformVersions.map((pV) => ({ id: pV.id, label: pV.name, value: pV.id }))}
    />
  )
}

const VersionFilter = ({
  filter,
  onFilterChange,
}: {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}) => {
  return (
    <ModalFilter
      Modal={SelectVersion}
      placeholder='Choose Version'
      filter={filter}
      onFilterChange={onFilterChange}
    />
  )
}

export const getPlatformVersionFilterFields = (): FieldSettings[] => [
  {
    name: 'Platform',
    label: 'Platform',
    filter: PlatformFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: 'UpdateRequired',
    label: 'Update Required',
    filter: BooleanFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
  {
    name: 'Version',
    label: 'Version',
    filter: VersionFilter,
    operators: [
      {
        text: GridFilterOperatorNameEnum.equalOperator,
        operator: GridFilterOperatorEnum.equalOperator,
      },
      {
        text: GridFilterOperatorNameEnum.notEqOperator,
        operator: GridFilterOperatorEnum.notEqOperator,
      },
    ],
  },
]
